import { useAutoQuery } from '@/utils/useAutoQuery'
import { tempPagination } from '../config'

export default {
  props: ['tableData'],
  data() {
    const { list, columns, pagination, oLoading, attrs, events, showHeader = true, highlightCurrentRow = true } = this.tableData
    const defaultPagination = { ...tempPagination }
    // 如果开启自动查询，则将url中参数赋给pagination
    if (this.activeAutoQuery) {
      const aq = useAutoQuery()
      const { pageNum, pageSize } = aq.p || {}
      pageNum && (defaultPagination.pageNum = Number(pageNum))
      pageSize && (defaultPagination.pageSize = Number(pageSize))
    }
    return {
      defaultPagination,
      list: list || [],
      columns: columns || [], // 表格数据
      pagination: typeof (pagination) !== 'boolean' && columns && Array.isArray(columns) && columns.length > 0 ? Object.assign({}, defaultPagination, pagination) : false,
      sorter: null,
      oLoading: Object.assign({ search: false }, oLoading),
      loading: false,
      attrs: attrs || {},
      events: events || {},
      isSearch: true, // 是否需要搜索
      showHeader, // 是否展示表头
      highlightCurrentRow, // 是否高亮当前行
    }
  },
  watch: {
    tableData: {
      handler(val) {
        this.list = val.list || []
        if (val.columns) {
          this.columns = [...val.columns]
        }
        const { columns } = this
        this.pagination = typeof (val.pagination) !== 'boolean' && columns && Array.isArray(columns) && columns.length > 0 ? Object.assign({}, this.defaultPagination, val.pagination) : false
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    isShowTable() {
      const { columns } = this
      return !!(columns && Array.isArray(columns) && columns.length > 0)
    },
  },
  inject: ['activeAutoQuery'],
  methods: {
    // 设置是否是带有表单搜索
    /**
     * isSearch:true-搜索；false-仅展示表格
     */
    setIsSearch(flag) {
      this.isSearch = flag
    },
    // 分页查询&表格排序
    paginationChange(payload, isPage) {
      const { isSearch } = this
      const { pagination, sorter, searchParams } = payload
      if (typeof (this.pagination) !== 'boolean') {
        this.pagination.pageSize = pagination.pageSize || 10
        this.pagination.pageNum = pagination.pageNum || 1
        // 如果开启自动查询，则更新autoQuery中的p和f
        if (this.activeAutoQuery) {
          const { pageNum, pageSize } = pagination
          const aq = useAutoQuery()
          aq.p = {
            pageNum,
            pageSize,
          }
        }
      }
      // 表格排序
      this.sorter = sorter
      if (searchParams && !searchParams.sorter) {
        this.$refs.blmCommonTable.$refs.table.clearSort()
      }
      // isPage:是否是列表分页点击；isSearch：是否有搜索表单
      if (isSearch && isPage) {
        this.$emit('searchForm')
        return
      }
      this.getData(payload)
    },

    // 获取表格列表数据
    async getData(payload) {
      const { queryData, customProcessingData, customUseData, apiFn, defaultParams } = this.tableData
      this.$emit('setFormLoading', true)
      this.loading = true

      try {
        let tempParams
        if (typeof (this.pagination) !== 'boolean') {
          tempParams = {
            pageSize: this.pagination.pageSize,
            pageNum: this.pagination.pageNum,
          }
        }
        const params = Object.assign({}, tempParams, payload.searchParams, defaultParams)
        if (queryData) { // 如果存在自定义获取数据方法(包含不用组件table情况)
          const res = await queryData(params)
          if (res) {
            this.$emit('setFormLoading', false)
            this.loading = false
          }
          return
        }
        // const { code, data } = await apiFn.call(this, params)
        const res = await apiFn.call(this, params)
        const { code, data } = res
        this.$emit('setFormLoading', false)
        this.loading = false
        if (code === 1) {
          if (customUseData) {
            customUseData(data)
          }
          // 由于存在这样的情况：1、部分接口data是数组，部分接口items是数组 2、没用到组件表格情况，所以把数据抛回业务侧自己处理，处理后更新configData中的table数据
          if (customProcessingData) {
            customProcessingData(data)
            return
          }
          let tableData = []
          let totalNum = 0
          if (Array.isArray(data)) {
            tableData = data
            totalNum = res.totalNum
          } else if (Array.isArray(data.items)) {
            tableData = data.items
            totalNum = data.totalNum
          }
          if (this.tableData.list) {
            this.tableData.list = tableData
          } else {
            this.list = tableData
          }
          if (typeof (this.pagination) !== 'boolean') {
            this.pagination.total = totalNum
          }
        }
      } catch (error) {
        this.$emit('setFormLoading', false)
        this.loading = false
      }
    },
  },
  destroyed() {
    this.pagination = tempPagination
  },
}
